import React, {Component} from 'react';
import './Main.scss';
import {title} from '../../helpers/exportConsts';
import routes from "../../helpers/exportRoutes";

class Main extends Component {
  render() {
    return(
     <div className={'main fix'}>
       <div className={'landing'}>
         {title('4rem')}
         <br/><br/>
         <div className={'row justify-content-center'}>
           <a href={routes.game}>
             <button className={'action'} type={'submit'}>Let's play!</button>
           </a>
         </div>
       </div>
     </div>
    )
  }
}

export default Main;